<template>
  <div class="contention" v-if="flag == true">
    <div class="title">
      <img src="../../../images/drawactivity/title.png" alt="" />
      <span class="actiiname">{{ activName }}</span>
    </div>
    <div class="tips">
      <div @click="toPath">
        抽奖规则
      </div>
      <div
        @click="
          $router.push({
            path: '/myprize',
            query: {
              id: activID,
			  type:1,
            },
          })
        "
      >
        我的奖品
      </div>
    </div>
    <main class="draw">
      <LuckyGrid
        ref="LuckDraw"
        width="9.06667rem"
        height="9.06667rem"
        :blocks="blocks"
        :prizes="prizes"
        :buttons="buttons"
        :default-style="{
          borderRadius: 8,
        }"
        :active-style="activeStyle"
        @start="startCallBack"
        @end="endCallBack"
      />
    </main>
    <footer class="footer" v-if="drawList.length != 0">
      <vue-seamless-scroll
        background="transparent"
        :class-option="optionHover"
        class="seamless"
        color="#fff"
        :data="drawList"
      >
        <ul>
          <li v-for="(item, index) in drawList" :key="index">
            中奖名单：{{ item.loginPhone }}抽中{{ item.activityPrizeName }}
          </li>
        </ul>
      </vue-seamless-scroll>
      <!-- <van-notice-bar
        background="transparent"
        style="height:100%"
        color="#fff"
        :scrollable="false"
      >
        <van-swipe
          vertical
          class="notice-swipe"
          :autoplay="3000"
          :show-indicators="false"
        >
          <template>
            <van-swipe-item v-for="(item, index) in drawList" :key="index">
              中奖名单：{{ item.loginPhone }}抽中{{ item.activityPrizeName }}
            </van-swipe-item>
          </template>
        </van-swipe>
      </van-notice-bar> -->
    </footer>
    <van-popup v-model="show">
      <template v-if="type == 1">
        <Prize :imgUrl="picture">{{ name }}</Prize>
        <div class="btn" @click="confirmGet">立即领取</div>
      </template>
      <template v-if="type == 0">
        <prize-no></prize-no>
        <div class="btn" @click="show = false">好的</div>
      </template>
    </van-popup>
  </div>
  <van-empty
    v-else
    class="custom-image"
    image="https://img01.yzcdn.cn/vant/custom-empty-image.png"
    description="暂无可参与的活动哦~"
  />
</template>

<script>
import VueSeamlessScroll from "vue-seamless-scroll";
import { LuckyGrid } from "vue-luck-draw";
import { drawrule, activitygift, getActivityWinnerList, getUserGiftCount } from "@/api/draw.js";
import VueElementLoading from 'vue-element-loading';
import { Toast,Dialog } from "vant";
import Prize from "./prize.vue";
import prizeNo from "./prize_no.vue";

export default {
  data() {
    return {
      optionHover: {
        hoverStop: false,
		limitMoveNum:2,
		step:0.3,
		direction:1,
		openWatch:true,
      },
	  count:null,
	  use_integral:null,
	  activityStatus: null,//0:未开始 1:进行中 2:已经结束
      flag: false,
      activName: "",
      activity_prize_id: null,
      picture: null,
      name: null,
      type: null,
      show: false,
      userInfo: null,
	  winnerId:null,
	  isActive:false,
      blocks: [
        { padding: "10px 10px", background: "transparent" },
        {
          padding: "23px",
          paddingRight: "90px",
          background: "transparent",
        },
        { padding: "0px", background: "transparent" },
      ],
      prizes: null,
      activeStyle: {
        background: "#FBC229",
        shadow: "",
      },
      buttons: [
        {
          x: 1,
          y: 1,
		  background: 'rgba(0,0,0,0)',
		  imgs: [{
			  src: require('../../../images/drawactivity/kaishichoujiang.png'),
			  width: '100%',
			  height: '100%',
		            }],
        },
      ],
      activID: null,
      drawList: [],
      click: false,
    };
  },
  components: {
    VueSeamlessScroll,
    LuckyGrid,
    Prize,
    prizeNo,
	VueElementLoading,
  },
  mounted() {
    this.userInfo = JSON.parse(window.sessionStorage.getItem("loginInfo"));
    this.getData(this.$cookies.get("internetBarId"));
  },
  methods: {
    confirmGet() {
      this.$router.push({
        path: "/info",
        query: {
			winnerId:this.winnerId,
          activity_id: this.activID,
          activity_prize_id: this.activity_prize_id,
          activityPrizeName: this.name,
        },
      });
    },
	//获取底部滚动中奖列表
    async getDrawList(activityId) {
      const data = await getActivityWinnerList({ activityId });
      console.log("中奖列表", data);
      if (data.code == 200) {
        data.data.forEach((item) => {
          item.loginPhone =
            item.loginPhone.substr(0, 3) + "****" + item.loginPhone.substr(7);
        });
        this.drawList = data.data;
      }
    },
	//获取剩余抽奖次数
	async getGiftCount(params){
		
		const data = await getUserGiftCount(params);
		console.log("剩余次数",data);
		if(data.code == 200){
			this.count = data.data.count;
		}
	},
	//获取活动详情
    async getData(internetBarId) {
      try {
        const data = await drawrule({ internetBarId });
        console.log(data);
        if (data.data == null) {
          this.flag = false;
        } else {
          this.flag = true;
        }
		const params = {
			userId: this.userInfo.id,
			activityId: data.data.activity.id,
		};
		this.getGiftCount(params);
        this.getDrawList(data.data.activity.id);
		console.log('activietystatus======',data.data.activity.activity_status);
		this.activityStatus = data.data.activity.activity_status;
		console.log('activietystatus======',this.activityStatus);
        if (data.code == 200 && data.data.prizeList.length > 0) {
          this.activName = data.data.activity.name;
          this.activID = data.data.activity.id;
          this.click = true;
		  this.use_integral = data.data.activity.use_integral;
          console.log(this.click);
          data.data.prizeList.forEach((item) => {
            if (item.name == "谢谢惠顾" ) {//|| item.residue_number == 0
              item.picture = require("../../../images/weixiao.png");
              item.name = "谢谢参与";
            }
			else if (item.residue_number == 0){
				item.name = item.name+"(已抽完)";
			}
          });
          this.getList(data.data.prizeList);
        } else {
          Toast(data.message);
          let list = [];
          for (var i = 0; i < 8; i++) {
            list.push({
              id: i + 1,
              picture:
                "https://img2.baidu.com/it/u=1509350169,3971547504&fm=26&fmt=auto&gp=0.jpg",
              name: "敬请期待",
              type: 1,
            });
          }
          this.click = false;
          this.getList(list);
        }
      } catch (e) {}
    },
    toPath() {
      if (this.click) {
        this.$router.push("/drawrule");
      } else {
        Toast("敬请期待");
      }
    },
    getList(data) {
      console.log(data);
      const prizes = [];
      this.luckyNum = 1;
      let axis = [
        [0, 0],
        [1, 0],
        [2, 0],
        [2, 1],
        [2, 2],
        [1, 2],
        [0, 2],
        [0, 1],
      ];
      for (let i = 0; i < 8; i++) {
        let item = data[i];
        prizes.push({
          ...item,
          index: i,
          x: axis[i][0],
          y: axis[i][1],
          borderRadius: 0,
          fonts: [
            {
              text: item.name,
              top: "70%",
              fontSize: item.name.length > 5 ? "10px" : "13px",
			  fontColor:item.residue_number == 0 && item.type == 1 ? "#666666":"#000000",
            },
          ],
          imgs: [{ src: item.picture, width: "55%", top: "8%" ,height:"55%"}],
		  background: item.residue_number == 0 && item.type == 1 ? "#999999":"#ffffff",
        });
      }
      console.log(prizes);
      this.prizes = prizes;
    },
	//抽奖接口
	async getDrawPrize(){
		Toast.loading({
			duration:0,
			forbidClick:true,
			message:"抽奖中",
			vertical:true
		});
		this.click = false;
		const params = {
			userId: this.userInfo.id,
			activityId: this.activID,
			internetBarId: this.$cookies.get("internetBarId"),
		};
		//调取抽奖接口
		const data = await activitygift(params);
		console.log('抽奖结果',data);
		if (data.code == 10002) {
			Toast.clear();
			this.click = true;
			this.$refs.LuckDraw.stop();
			Toast(data.message);
		} 
		else if (data.data.activityPrize == null || data.data.activityPrize.residue_number == 0){
			console.log('返回的为空',data.data.activityPrize);
			this.count -- ;
			Toast.clear();
			this.$refs.LuckDraw.play();
			let index = null;
			this.prizes.forEach((item, i) => {
			if (item.name == "谢谢惠顾" || item.name == "谢谢参与") {
				index = i;
				console.log('返回的index===',index);
				}
			});
			this.type = 0;
			this.picture = require("../../../images/weixiao.png");
			this.name = "谢谢参与";
			// this.activity_prize_id = dataId;
			this.$refs.LuckDraw.stop(index);
			this.click = true;
			this.getDrawList(this.activID);
			this.getData(this.$cookies.get("internetBarId"));	
		}
		else if (data.data.activityPrize){
			this.count -- ;
			Toast.clear();
			this.click = true;
			this.$refs.LuckDraw.play();
			let index = null;
			this.prizes.forEach((item, i) => {
				if (item.id == data.data.activityPrize.id) {
					index = i;
				}
			});
			this.type = data.data.activityPrize.type;
			this.picture = data.data.activityPrize.picture;
			this.name = data.data.activityPrize.name;
			this.activity_prize_id = data.data.activityPrize.id;
			this.winnerId = data.data.userWinnerId;
			this.$refs.LuckDraw.stop(index);
			this.click = true;
			this.getDrawList(this.activID);
			this.getData(this.$cookies.get("internetBarId"));
			// Toast(data.data.name)
		}
		else 
		{
			Toast.clear();
			this.click = true;
			console.log("超时了");
			}
	},
	//点击抽奖，开始滚动
    async startCallBack() {
		console.log('activietystatus======',this.activityStatus);
		if(this.activityStatus == 2){
			Toast("很遗憾，该活动已结束");
			console.log('activietystatus======',this.activityStatus);
			return;
		}
		if(this.activityStatus == 0){
			Toast("别着急，该活动还未开始");
			console.log('activietystatus======',this.activityStatus);
			return;
		}
		if (this.click == true) {
			if(this.count < 1){
				Toast("今日抽奖次数已用尽");
				// Dialog.confirm({
				//   title: "提示",
				//   message:"今日抽奖次数已用尽，是否使用"+this.use_integral+"积分进行抽奖？",
				//   width:"270px",
				//   confirmButtonColor:"#008CFF",
				//   confirmButtonText:"确定"
				// })
				//   .then(() => {
				// 	  console.log(77777);
				//     // this.requestDeleteUser(id);
				// 	this.getDrawPrize();
				//   })
				//   .catch(() => {
				// 	  console.log(1231312);
				//     // on cancel
				//   });
				  return;
			}
			this.getDrawPrize();
			// this.$refs.LuckDraw.play();
		}
		else {
			Toast("请耐心等待抽奖结果，请勿退出");
		}
    },
    endCallBack(prize) {
		console.log('停止了');
		this.show = true;
		this.luckyNum--;
    },
  },
};
</script>
<style lang="scss" scoped>
.contention {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url("../../../images/drawactivity/bgc.png") no-repeat;
  background-size: cover;
  background-position: center center;
  .title {
    width: 290px;
    height: 102px;
    margin: 0 auto;
    margin-top: 40px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
    .actiiname {
      position: absolute;
      width: 230px;
      height: 23px;
      text-align: center;
      line-height: 23px;
      // background-color: red;
      left: 50%;
      bottom: 6px;
      font-size: 13px;
      color: #621ff0;
      transform: translateX(-50%);
    }
  }
  .tips {
    width: 60px;
    position: fixed;
    top: 110px;
    right: 0;
    font-size: 8px;
    text-align: center;

    font-family: PingFang SC;
    font-weight: 500;
    color: #eeeeee;
    div {
      height: 25px;
      line-height: 25px;
      background: rgba($color: #000000, $alpha: 0.2);
      border-radius: 12.5px 0 0 12.5px;
      &:last-child {
        margin-top: 10px;
      }
    }
  }
  .draw {
    width: 340px;
    height: 340px;
    background: url("../../../images/drawactivity/jiangchi.png");
    background-size: 100% 100%;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -40%);
  }
  .footer {
    width: 340px;
    height: 62px;
    background: url("../../../images/drawactivity/mingdan.png");
    background-size: cover;
    position: fixed;
    bottom: 35px;
    left: 50%;
    transform: translateX(-50%);
    div {
      height: 100%;
    }
    .seamless {
      color: ghostwhite;
      height: 100%;
      overflow: hidden;
      font-size: 14px;
      // text-align: left;
      li {
        margin-bottom: 10px;
      }
    }
  }
  .btn {
    width: 195px;
    height: 34px;
    background: linear-gradient(90deg, #6a3bce 0%, #865cdf 100%);
    border-radius: 17px;
    margin: 0 auto;
    margin-top: 22px;
    margin-bottom: 22px;
    font-size: 15px;
    line-height: 34px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }
}
</style>
<style>
.van-popup--center {
  border-radius: 16px;
}
.notice-swipe {
  height: 62px;
  line-height: 62px;
  white-space: nowrap; /*内容超宽后禁止换行显示*/
  overflow: hidden; /*超出部分隐藏*/
  text-overflow: ellipsis; /*文字超出部分以省略号显示*/
}
.van-swipe-item {
  white-space: nowrap; /*内容超宽后禁止换行显示*/
  overflow: hidden; /*超出部分隐藏*/
  text-overflow: ellipsis; /*文字超出部分以省略号显示*/
}
</style>
